import { Component } from '@angular/core';
import { ShareService } from '@netfoundry-ui/shared/services';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import _ from 'lodash';

@Component({
    selector: 'app-table-cell-sparklines',
    templateUrl: './table-cell-sparklines.component.html',
    styleUrls: ['./table-cell-sparklines.component.scss'],
})
export class TableCellSparklinesComponent implements ICellRendererAngularComp {
    params;
    item = {
        name: undefined,
        frontdoorId: undefined
    };
    data = {
        labels: [] as string[],
        datasets: [
            {
            data: [],
            borderColor: 'blue',
            backgroundColor: 'lightblue',
            fill: false,
            tension: 0.3,
            pointRadius: 0,

            },
            {
            data: [],
            borderColor: 'green',
            backgroundColor: 'lightgreen',
            fill: false,
            tension: 0.3,
            pointRadius: 0,
            }
        ]
    }

options: any = {
  responsive: false,
  maintainAspectRatio: false,
  plugins: {
    legend: { display: false },
    tooltip: { enabled: false }
  },
  scales: {
    x: { display: false },
    y: {
      display: false,
      min: 0,
      max: 1   // default, will be overridden dynamically
    }
  },
  elements: {
    line: { borderWidth: 2 }
  }
};
constructor(
            private shareService: ShareService,
        ) {}


    agInit(params: ICellRendererParams): void {
        this.item = params.node.data;
        this.getShareSparklines();
    }

    refresh(params: ICellRendererParams): boolean {
        this.item = params.data;
        this.getShareSparklines();
        return true;
    }

    getShareSparklines() {
        this.shareService.getSparklinesByShare(this.item.frontdoorId, this.item.name).subscribe((data: any) => {
            if (data.sparklines) {
                    const rxData: number[] = [];
                    const txData: number[] = [];
                    const labels: string[] = [];
                for(const sample of data.sparklines[0].samples) {
                        rxData.push(sample.rx);
                        txData.push(sample.tx);
                        labels.push("");
                }
                this.data.datasets[0].data = rxData
                this.data.datasets[1].data = txData
                const allData = [...rxData, ...txData];
                const chartMax = Math.max(...allData) || 1; // Use 1 as a fallback for empty data
                this.data.labels = labels;
                this.options = {
                    responsive: false,
                    maintainAspectRatio: false,
                    plugins: {
                    legend: { display: false },
                    tooltip: { enabled: false }
                    },
                    scales: {
                    x: { display: false },
                    y: { 
                        display: false, 
                        min: 0, 
                        max: chartMax + (chartMax * 0.1) }
                    },
                    elements: {
                    line: { borderWidth: 2 }
                    }
                };
                    } else {

                    const sampleData = [
                    {
                        'rx': 0,
                        'tx': 0
                    },
                                        
                    {
                        'rx': 0,
                        'tx': 0
                    },
                    {
                        'rx': 0,
                        'tx': 0
                    },
                    {
                        'rx': 0,
                        'tx': 0
                    },
                    {
                        'rx': 0,
                        'tx': 0
                    },
                    {
                        'rx': 0,
                        'tx': 0
                    },
                    {
                        'rx': 0,
                        'tx': 0
                    },
                    
                    ]
                    const rxData: number[] = [];
                    const txData: number[] = [];
                    const labels: string[] = [];
                for(const sample of sampleData) {
                        rxData.push(sample.rx);
                        txData.push(sample.tx);
                        labels.push("");
                }
                this.data.datasets[0].data = rxData
                this.data.datasets[1].data = txData
                const allData = [...rxData, ...txData];
                const chartMax = Math.max(...allData) || 1; // Use 1 as a fallback for empty data
                this.data.labels = labels;
                this.options = {
                    responsive: false,
                    maintainAspectRatio: false,
                    plugins: {
                    legend: { display: false },
                    tooltip: { enabled: false }
                    },
                    scales: {
                    x: { display: false },
                    y: { 
                        display: false, 
                        min: 0, 
                        max: 1 }
                    },
                    elements: {
                    line: { borderWidth: 2,
                     }
                    }
                };

                    }

            }
            
        )
    }




}
